import axios from "axios";

export default {
    //登录标识
    token: false,

    // 请求路径
    // http: "http://localhost:9521/HRIS/",
    // http: "http://192.168.0.250:9331/HRIS/",
    // http: "http://192.168.0.180:9521/HRIS/",
    
    http: "https://mybj.huajunkeji.top/cleaning/",

    // updateFileUrl: "https://myjt.huajunkeji.top/HRIS/file/upload",

    updateFileUrl: "https://mybj.huajunkeji.top/cleaning/file/upload",

    //集团名称
    group_name: "",

    //城市
    cityList: [{
        city: "沈阳"
    },
    {
        city: "大连"
    },
    {
        city: "鞍山"
    },
    {
        city: "辽阳"
    },
    {
        city: "本溪"
    },
    {
        city: "锦州"
    },
    {
        city: "天津"
    },
    {
        city: "廊坊"
    },
    {
        city: "北京"
    },
    {
        city: "青岛"
    },
    {
        city: "济南"
    },
    {
        city: "潍坊"
    },
    {
        city: "泰安"
    },
    {
        city: "菏泽"
    },
    {
        city: "辽阳"
    },
    {
        city: "法库"
    },
    {
        city: "烟台"
    },
    {
        city: "抚顺"
    },
    {
        city: "丹东"
    },
    {
        city: "葫芦岛"
    },
    {
        city: "新民"
    },
    {
        city: "长春"
    },
    {
        city: "吉林"
    },
    {
        city: "呼和浩特"
    },
    {
        city: "赤峰"
    },

    ],

    //获取当前时间
    getNowTime() {
        var now = new Date();
        var year = now.getFullYear(); //得到年份
        var month = now.getMonth(); //得到月份
        var date = now.getDate(); //得到日期
        month = month + 1;
        month = month.toString().padStart(2, "0");
        date = date.toString().padStart(2, "0");
        var defaultDate = `${year}-${month}-${date}`;
        return defaultDate;
    },
    //获取当前时间
    getNowTimes() {
        var date = new Date(),
            year = date.getFullYear(),
            month = date.getMonth() + 1;
        month >= 1 && month <= 9 ? (month = "0" + month) : "";
        var timer = year + '-' + month;
        return timer;
    },
	//获取当前时间
	getNowTimeyear() {
	    var date = new Date(),
	        year = date.getFullYear(),
	        month = date.getMonth() + 1;
	    month >= 1 && month <= 9 ? (month = "0" + month) : "";
	    var year = year;
	    return year;
	},

    //当前登陆人数据
    user: {
        id: "", //用户id
        name: "", //用户名
        role_id: "", //角色id
        staff_id: "", //员工id
        phone: "", //手机号
        mailbox: "", //邮箱
        sysJurisdictionList: {},//权限组
    },

    //同步请求方法
    async AxiosPost(url, record) {
        var result;
        await axios.post(this.http + url, record)
            .then((response) => {
                //正常返回
                result = response.data;
            }).catch((error) => {
                console.log(error)
                //服务器未响应
                result = "-2000";
            });
        //返回值
        return result;
    },

    async AxiosGet(url) {
        var result;
        await axios.get(this.http + url)
            .then((response) => {
                //正常返回
                result = response.data;
            }).catch((error) => {
                console.log(error)
                //服务器未响应
                result = "-2000";
            });
        return result;
    },
}



// WEBPACK FOOTER //
// ./src/data.js